export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ModalForm.vue?vue&type=template&id=42853450&"


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/public/forms/ModalForm.vue?vue&type=template&id=42853450&
// module id = 1639
// module chunks = 0